// extracted by mini-css-extract-plugin
var _1 = "CreateComment_avatar__37cb6";
var _2 = "CreateComment_notEmpty__ec353";
var _3 = "CreateComment_root__1a66d";
var _4 = "CreateComment_send__2ff18";
var _5 = "CreateComment_text__be3e4";
export { _1 as "avatar", _2 as "notEmpty", _3 as "root", _4 as "send", _5 as "text" }
